/** Levels of Fibonacci Retracement (po-chart-visual-spec.md §7.5), from the second point (0) through the first one (1) and beyond. */
export const FIBONACCI_LEVELS = [0, 0.236, 0.382, 0.5, 0.618, 0.786, 1, 1.236, 1.272, 1.382, 1.5, 1.618, 1.786, 2.618];

/** Levels of Fibonacci Fan on both axes of its grid (§7.5), from the first point (0) to the second one (1). */
export const FIBONACCI_FAN_LEVELS = [0, 0.25, 0.382, 0.5, 0.618, 0.75, 1];

/** «Levels: Values / Percents» of Fibonacci Retracement, the names as in PO, like the inputs of indicators. */
export const DRAWING_LEVEL_FORMAT = {
  VALUES: "Values",
  PERCENTS: "Percents",
};

const PERCENT_DIGITS = 2;

/**
 * @param {number} level - e.g. 0.618
 * @param {string} format - DRAWING_LEVEL_FORMAT value
 * @returns {string} «0.618» or «61.80%»
 */
export const formatDrawingLevel = (level, format) =>
  format === DRAWING_LEVEL_FORMAT.PERCENTS ? `${(level * 100).toFixed(PERCENT_DIGITS)}%` : String(level);
